import api from './api';

export interface CreateChildDto {
  name: string;
  birthdate: string;
  gender?: string;
  clientId: string;
}

export interface ChildFromApi {
  id: string;
  name: string;
  birthdate: string;
  gender?: string;
  clientId: string;
  /** Pós-refactor client→sub: null = criança "órfã", sem sub vinculada. */
  subscriptionId?: string | null;
}

/**
 * #362: as rotas públicas de criança só aceitam o placeholder da própria sessão de
 * checkout. A renovação/upgrade mexe nas crianças de um cadastro de verdade e prova
 * posse mandando o próprio link (token de renovação) neste header.
 */
const comRenovacao = (renewalToken?: string) =>
  renewalToken ? { headers: { Authorization: `Renewal ${renewalToken}` } } : undefined;

export const ChildService = {
  async create(child: CreateChildDto, renewalToken?: string) {
    const { data } = await api.post('/children', child, comRenovacao(renewalToken));
    return data.data;
  },

  async update(id: string, child: Partial<CreateChildDto>, renewalToken?: string) {
    const { data } = await api.patch(`/children/checkout/${id}`, child, comRenovacao(renewalToken));
    return data.data;
  },

  async getByClientId(clientId: string, renewalToken?: string): Promise<ChildFromApi[]> {
    const { data } = await api.get(`/children/client/${clientId}`, comRenovacao(renewalToken));
    return data.data || [];
  },
};
